<template>
  <MobileBottomAppBar v-show="!isDrawerOpened">
    <div class="px-4 flex items-center justify-between w-full">
      <div
        v-for="shop in bettingShopsToDisplayInBar"
        :key="shop.id"
        class="box-border border rounded-full"
        :class="shop.id == bettingShopId ? 'border-primary_500' : 'border-neutral_400'"
      >
        <NuxtLink :to="localePath(`/betting-shop/${shop.id}`)">
          <img class="h-10" :src="shop.logo" :alt="`logo of ${shop.name}`" />
        </NuxtLink>
      </div>
      <p
        class="text-[12px] text-primary_500 font-medium leading-[150%] cursor-pointer px-4"
        @click="isDrawerOpened = true"
      >
        +{{ bettingShopsToDisplayInDrawer.length }}
      </p>
    </div>
  </MobileBottomAppBar>
  <BettingShopsMobileDrawer
    :is-open="isDrawerOpened"
    :betting-shops="bettingShopsToDisplayInDrawer"
    @close-dialog="isDrawerOpened = false"
  />
</template>
<script lang="ts" setup>
import type { BettingShop } from '~/interfaces';
import { bettingShopRepository } from '~/repositories/bettingShopsRepository';

const { $api } = useNuxtApp();
const route = useRoute();
const bettingShopRepo = bettingShopRepository($api);
const localePath = useLocalePath();
const bettingShopsToDisplayInBar = ref<BettingShop[]>([]);
const bettingShopsToDisplayInDrawer = ref<BettingShop[]>([]);
const bettingShopId = parseInt(route.params.id as string);
const isDrawerOpened = ref(false);
onMounted(async () => {
  const bettingShops = await bettingShopRepo.getBettingShops();
  const index = bettingShops.findIndex((shop) => shop.id === bettingShopId);
  if (index !== -1) {
    const [selectedShop] = bettingShops.splice(index, 1);
    bettingShops.unshift(selectedShop);
  }
  bettingShopsToDisplayInBar.value = bettingShops.slice(0, 5);
  bettingShopsToDisplayInDrawer.value = bettingShops.slice(5);
});
</script>
